import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function DelRowIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m10.962 6.125-3.646 3.75m0-3.75 3.646 3.75M2.286 8.6l2.624 3.6c.214.293.321.44.457.546a1.2 1.2 0 0 0 .4.206c.164.048.342.048.699.048h4.618c1.02 0 1.53 0 1.92-.204a1.85 1.85 0 0 0 .797-.82C14 11.576 14 11.05 14 10V6c0-1.05 0-1.575-.199-1.976a1.85 1.85 0 0 0-.796-.82C12.615 3 12.105 3 11.084 3H6.466c-.357 0-.535 0-.698.048q-.22.066-.401.206c-.136.106-.243.253-.457.546L2.286 7.4c-.157.215-.236.323-.266.44a.64.64 0 0 0 0 .32c.03.117.109.225.266.44" /></svg>
  );
}

export default DelRowIcon;
